import React from 'react';

const Contact = () => {
    return (
      <div className="contact-container">
        <h2>Контакты</h2>
        <div className="contact-details">

          <div className="contact-item">
            <i className="fas fa-phone contact-icon"></i>
            <div>
              <h3>Телефон:</h3>
              <p>+7 926-758-20-21</p>
            </div>
          </div>
          <div className="contact-item">
            <i className="fas fa-envelope contact-icon"></i>
            <div>
              <h3>Email:</h3>
              <p>globalIT@gmail.com</p>
            </div>
          </div>
        </div>
        <h2>Ассоциация Электронных Коммуникаций “РАЭК”</h2>
        <div className="contact-details">
        <div className="contact-item">
            <i className="fas fa-map-marker-alt contact-icon"></i>
            <div>
              <h3>Адрес:</h3>
              <p>123557, Россия, Москва,
              Пресненский вал, д. 27, стр. 2,
              Корпус "iЮНЬ", 1 этаж
              </p>
            </div>
          </div>
          <div className="contact-item">
            <i className="fas fa-phone contact-icon"></i>
            <div>
              <h3>Телефон:</h3>
              <p>+7 495 950 56 51</p>
            </div>
          </div>
          <div className="contact-item">
            <i className="fas fa-envelope contact-icon"></i>
            <div>
              <h3>Email:</h3>
              <p>info@raec.com</p>
            </div>
          </div>
        <div className="contact-item">
            <i className="fas fa-building contact-icon"></i>
            <div>
              <h3>ИНН/КПП:</h3>
              <p>7719286665/770301001</p>
            </div>
          </div>

        </div>
      </div>
    );
  };
  
  export default Contact;